import { getDateFromTimestamp } from '@atlassian/jira-software-roadmap-utils/src/utils/dates';
import type { KeyDate } from '../../../../common/types/key-date.tsx';

// This function is used to generate a format '<release_name> <release_date>' for screen readers to announce(Accessibility purpose)
export const getReleaseNamesAndDatesAlly = (keyDates: ReadonlyArray<KeyDate>) =>
	keyDates.map(({ name, date }) => `${name} ${getDateFromTimestamp(date)}`).join(', ');
